<h1 mat-dialog-title>{{ 'map.sidebar.dynamic_layers.form.title_modal' | translate }}</h1>
<div mat-dialog-content [formGroup]="layersForm" class="dynamic-layer-form-wrapper">
  <div class="visibility" *ngIf="publicPermission">
    <mat-slide-toggle formControlName="visibility">
      <span class="visibility-text">{{ 'map.sidebar.bookmark.set_public' | translate }}</span>
    </mat-slide-toggle>
    <mat-icon class="visibility-eye">{{
      layersForm.get('visibility').value ? 'visibility' : 'visibility_off'
    }}</mat-icon>
  </div>

  <div class="row">
    <div class="col-12 form-field-container mb-2">
      <mat-form-field appearance="fill">
        <mat-label>{{ 'map.sidebar.dynamic_layers.form.service_type' | translate }}</mat-label>
        <mat-select formControlName="serviceType" required (selectionChange)="onChangeType($event)">
          <mat-option *ngFor="let type of typeList" [value]="type">
            {{ type }}
          </mat-option>
        </mat-select>
        <mat-error *ngIf="layersForm.get('serviceType').hasError('required')"
          >{{ 'common.required_field' | translate }}
        </mat-error>
      </mat-form-field>

      <mat-icon
        color="primary"
        class="me-2 clickable info-button"
        [inline]="true"
        #tooltip="matTooltip"
        [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.service_type' | translate"
        matTooltipPosition="above"
        matTooltipClass="info-button-tooltip"
        >info</mat-icon
      >
    </div>
  </div>

  <div class="row" *ngIf="serviceType === 'WMS' || serviceType === 'WMTS'">
    <div class="col-12 form-field-container mb-2">
      <mat-form-field appearance="fill" [floatLabel]="'always'">
        <mat-label>{{ 'map.sidebar.dynamic_layers.form.url' | translate }}</mat-label>
        <input matInput formControlName="url" required />
        <mat-error *ngIf="layersForm.get('url').hasError('required')"
          >{{ 'common.required_field' | translate }}
        </mat-error>
        <mat-error *ngIf="layersForm.get('url').hasError('malformed')"> Il formato dell'url non è corretto </mat-error>
        <mat-error *ngIf="layersForm.get('url').hasError('notFound')">
          Nessuna risorsa trovata, controlla l'url inserito
        </mat-error>
      </mat-form-field>
      <mat-icon
        color="primary"
        class="me-2 clickable info-button"
        [inline]="true"
        #tooltip="matTooltip"
        [matTooltip]="'map.sidebar.dynamic_layers.form.tooltips.url' | translate"
        matTooltipPosition="above"
        matTooltipClass="info-button-tooltip"
        >info</mat-icon
      >
    </div>
  </div>

  <div class="row" *ngIf="urlIsValid">
    <div class="col">
      <div class="row" style="max-height: 55vh; padding-top: 2px">
        <div *ngFor="let form of formsList | keyvalue">
          <ebw-monorepo-single-layer-form [id]="form.key"> </ebw-monorepo-single-layer-form>
          <hr *ngIf="formsList.size > 1" />
        </div>
      </div>
      <div class="row">
        <button mat-mini-fab color="primary" class="add-button" (click)="addForm()" *ngIf="urlIsValid">
          <mat-icon>add</mat-icon>
        </button>
      </div>
    </div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <button mat-stroked-button [mat-dialog-close]="false" color="primary">{{ 'common.close' | translate }}</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="!isSaveEnabled()">{{ 'common.save' | translate }}</button>
</div>
